export const parseVisibilityFlag = (value, defaultValue = true) => {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return ['1', 'true', 'yes', 'on'].includes(normalized);
  }
  if (typeof value === 'number') {
    return value !== 0;
  }
  return Boolean(value);
};

export const normalizeWidgetVisibility = (widget) => {
  if (!widget) {
    return false;
  }
  return parseVisibilityFlag(widget.visible, true);
};
